import { Button } from "react-bootstrap";
import { formatPrice } from "utils/helpers/functions/formatPrice";
import ProductTitle from "../../Products/ProductRowItems/ProductTitle";
import CountBadge from "../CounBadge";
import { safeFloatParse, safeIntParse } from "utils/helpers/safeParsing";
import { useSettings } from "context/SettingsContext";
import { useState, type MouseEvent } from "react";
import FormInput from "../../forms/FormInput";
import { useTranslation } from "react-i18next";

const ComingTableBody = ({aComing, setAComing, comingProcess, editable = true}: any) => {
    const { localSettings } = useSettings();
    const { t } = useTranslation(['Warehouses']);
    const rate = Number(localSettings?.RATE?.current || 1);
    const isUahMode = (Number(localSettings?.RATE?.current ?? 1) || 1) === 1;
    const [editPriceIndex, setEditPriceIndex] = useState<number | null>(null);
    const [editCountIndex, setEditCountIndex] = useState<number | null>(null);

    const handleClickDelete = (e,index) => {
        setAComing(prev=>(prev.filter((c,i)=>i!=index)))
        e?.currentTarget?.blur();
    }

    const handleChangeRow = (index: number, patch: Record<string, any>) => {
        setAComing((prev) =>
            prev.map((row, i) =>
                i !== index
                    ? row
                    : {
                          ...row,
                          coming: {
                              ...row.coming,
                              ...patch,
                          },
                      },
            ),
        );
    };

    const getPaymentFileUrl = (coming: any): string => {
        const aiUrl = String(coming?.coming?.aiMeta?.cloudFile?.publicUrl || '');
        if (aiUrl) return aiUrl;
        const cloudFiles = coming?.coming?.paymentAttachmentsCloud;
        if (Array.isArray(cloudFiles) && cloudFiles.length) {
            return String(cloudFiles[0]?.publicUrl || '');
        }
        return '';
    };

    const handleOpenPaymentFile = (e: MouseEvent, coming: any) => {
        e.preventDefault();
        e.stopPropagation();
        const fileUrl = getPaymentFileUrl(coming);
        if (!fileUrl) return;
        if (typeof window !== 'undefined') {
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
        }
    };
 
    return (
        <tbody>
            {aComing?.map((coming,index)=>{
                const price = formatPrice(coming?.coming?.price);
                const priceRate = formatPrice(coming?.coming?.priceRate);
                const canEdit = editable && !comingProcess;
                return (
                    <tr key={`${coming.ID}-${index}`}>
                        <td className="name">
                            <ProductTitle
                                product={{
                                    prodName:coming.product.label,
                                    vendorName:coming.product.vendor,
                                    prodStatus: 1
                                } as any}/>
                        </td> 
                        <td className="price">
                            {canEdit && editPriceIndex === index ? (
                                <FormInput
                                    compact={true}
                                    showForm={true}
                                    setShowForm={(show) => {
                                        if (!show) setEditPriceIndex(null);
                                    }}
                                    defaultValue={Number(coming?.coming?.price || 0)}
                                    decimalPlaces={2}
                                    callBack={(value) => {
                                        const nextPrice = safeFloatParse(value || 0);
                                        handleChangeRow(index, {
                                            price: nextPrice,
                                            priceRate: safeFloatParse(nextPrice * rate),
                                        });
                                        setEditPriceIndex(null);
                                    }}
                                />
                            ) : (
                                <h6
                                    className={`mb-1 text-break${canEdit ? ' cursor-pointer' : ''}`}
                                    onClick={() => canEdit && setEditPriceIndex(index)}
                                >
                                    {isUahMode ? `₴ ${price}` : `$ ${price}`}
                                    {coming.coming.payment ? (
                                        <span className="text-success ms-2">
                                            <i
                                                className={`bi ${getPaymentFileUrl(coming) ? 'bi-paperclip' : 'bi-cash-coin'}`}
                                                onClick={(e) => handleOpenPaymentFile(e, coming)}
                                                role="button"
                                                title={getPaymentFileUrl(coming) ? t('common:labelAttachments') : undefined}
                                            ></i>
                                        </span>
                                    ) : null}
                                </h6>
                            )}
                            {!isUahMode && (
                                <p className="text-muted f-12 mb-0 my-1">₴ {priceRate}</p>
                            )}
                            {coming?.coming?.aiMeta?.mode === 'new' && (
                                <span className="badge bg-light-warning mt-1">{t('aiBadge.new')}</span>
                            )}
                            {coming?.coming?.aiMeta?.mode === 'similar' && (
                                <span className="badge bg-light-info mt-1">{t('aiBadge.similar')}</span>
                            )}
                            {coming?.coming?.aiMeta?.mode === 'exact' && (
                                <span className="badge bg-light-success mt-1">{t('aiBadge.exact')}</span>
                            )}
                        </td>
                        <td className={`count text-end fw-medium ${coming.coming.cCount<0?'_text-danger':''}`}>
                            {canEdit && editCountIndex === index ? (
                                <FormInput
                                    compact={true}
                                    showForm={true}
                                    setShowForm={(show) => {
                                        if (!show) setEditCountIndex(null);
                                    }}
                                    defaultValue={Number(coming?.coming?.cCount || 0)}
                                    numbersOnly={true}
                                    callBack={(value) => {
                                        handleChangeRow(index, {
                                            cCount: safeIntParse(value),
                                        });
                                        setEditCountIndex(null);
                                    }}
                                />
                            ) : (
                                <div className="d-flex justify-content-end align-items-center">
                                    <div
                                        onClick={() => canEdit && setEditCountIndex(index)}
                                        className={canEdit ? 'cursor-pointer' : undefined}
                                    >
                                        <CountBadge count={coming.coming.cCount}/>
                                    </div>
                                </div>
                            )}
                        </td>
                        <td className="action">
                            <Button
                                size="sm"  
                                className="py-0 px-1 mb-1"
                                variant="light-danger"
                                disabled={comingProcess}
                                onClick={(e)=>handleClickDelete(e,index)}>
                                <i className="bi bi-trash3"></i>
                            </Button>
                        </td>
                    </tr>
                )
            })}
           
        </tbody> 
    )
}

export default ComingTableBody;